import { IUserProfileLocalRepository, CustomError, UserProfile } from "../../index";

export class AddLocalUserCompletedTaskUseCase {
    private localRepository: IUserProfileLocalRepository;

    constructor(localRepository: IUserProfileLocalRepository) {
        this.localRepository = localRepository;
    }

    execute(taskId: string): UserProfile | CustomError {
        return this.localRepository.addCompletedTask(taskId);
    }
}